import React, { createContext, FunctionComponent, PropsWithChildren, useContext, useMemo } from 'react';

type EnvironmentContextType = {
    appKey?: string;
    segmentWriteKey?: string;
    amplitudeApiKey?: string;
    fingerprintAccessKey?: string;
    sentryDsn?: string;
    customerIOSiteId?: string;
    environmentType?: string;
    isDev: boolean;
};

const environmentContext = createContext<EnvironmentContextType>({
    isDev: true,
});

const EnvironmentContextProvider: FunctionComponent<PropsWithChildren<unknown>> = ({ children }) => {
    const value = useMemo(
        () => ({
            appKey: process.env.NEXT_PUBLIC_APP_KEY,
            segmentWriteKey: process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY,
            amplitudeApiKey: process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY,
            fingerprintAccessKey: process.env.NEXT_PUBLIC_FINGERPRINT_ACCESS_KEY,
            isDev: process.env.NODE_ENV === 'development',
            sentryDsn: process.env.NEXT_PUBLIC_SENTRY_DSN_APP,
            customerIOSiteId: process.env.NEXT_PUBLIC_CUSTOMER_IO_SITE_ID,
            environmentType: process.env.NEXT_PUBLIC_ENVIRONMENT_TYPE,
        }),
        [],
    );
    return <environmentContext.Provider value={value}>{children}</environmentContext.Provider>;
};

export const useEnvironmentVariables = (): EnvironmentContextType => useContext(environmentContext);

export default EnvironmentContextProvider;
